<template>
	<v-dialog v-model="dialog" max-width="500">
		<v-card v-if="loading"
			color="primary"
			dark
		>
			<v-card-text>
				Please stand by
				<v-progress-linear
					indeterminate
					color="white"
					class="mb-0"
				></v-progress-linear>
			</v-card-text>
		</v-card>
		<v-card v-else>
			<v-toolbar>
				<v-toolbar-title>שיתוף משחק</v-toolbar-title>
			</v-toolbar>
			<v-card-text class="mt-3">
				<share-link :game="theGame"></share-link>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
			</v-card-actions>
		</v-card>

	</v-dialog>
</template>

<script>

	import {types as gameType} from "dev/store/modules/Game.module";
	import ShareLink from "dev/view/share/ShareLink";

	export default {
		name: "share-dialog",
		props: {
			value: {type: Boolean},
			game: {type: Object, required: true},

		},
		components: {ShareLink},
		data() {
			return {
				loading: false
			};
		},
		computed: {
			dialog: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			},
			theGame() {
				return this.$store.state.GameModule.game;
			}
		},
		methods: {},
		watch: {
			async dialog() {
				if (this.dialog) {
					this.loading = true;
					if (this.game.link) {
						this.$store.commit(gameType.GET, this.game.id);
					} else {
						await this.$store.dispatch(gameType.GET, this.game.id);
					}
					this.loading = false;
				}
			}
		},

	};
</script>

<style scoped>

</style>
